module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/8-e4a0ce70986479e59b927a70b20cd11c.png";